import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_CONFIG, APP_CONFIG } from '../config/authConfig';
import { ServerStatus, ServerStatusHookResult } from '../types/authTypes';

export const useServerStatus = (): ServerStatusHookResult => {
  const [serverStatus, setServerStatus] = useState<ServerStatus>('checking');

  const checkServerStatus = useCallback(async () => {
    try {
      await axios.get(`${API_CONFIG.BASE_URL}/health`, { 
        timeout: API_CONFIG.TIMEOUT 
      });
      setServerStatus('connected');
    } catch (err) {
      setServerStatus('error');
    }
  }, []);

  useEffect(() => {
    // Первоначальная проверка статуса
    checkServerStatus();

    // Установка интервала для периодической проверки
    const intervalId = setInterval(
      checkServerStatus, 
      APP_CONFIG.SERVER_STATUS_CHECK_INTERVAL
    );

    // Очистка интервала при размонтировании компонента
    return () => clearInterval(intervalId);
  }, [checkServerStatus]);

  return {
    serverStatus,
    checkServerStatus
  };
};
